import React from "react";
import { AnnouoncementsModal, Error, Header, Loader } from "../components";
import { useStateContext } from "../contexts/ContextProvider";
import { AgGridReact } from "ag-grid-react";
import { useState } from "react";
import BtnDelete from "../components/BtnDelete"
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-community/dist/styles/ag-theme-alpine-dark.css";
import axios, { Axios } from "axios";
import { useEffect } from "react";
const Announcements = () => {
  const { currentMode } = useStateContext();
  const [addList, setaddList] = useState([])

  const defaultColDefs = {
    sortable: true,
    filter: true,
  };

  
  const [columnDefs] = useState([
    { field: "category", flex: 2 },
    { field: "description", flex: 3 },
    { field: "dimensions", flex: 2 },
    { field: "approved", flex: 2 },
    { field: "price", flex: 2 },
    { field: "status", flex: 2 },
    { field: "whatsapp", flex: 3 },
    {
      field: "Action",
      flex: 2,
      cellRenderer: BtnDelete,
      cellRendererParams: {
        clicked: (item) => deleteAd(item),
      },
    
    },
  ]);


  

  const deleteAd =async(item) => {
    const config = {
        headers: { token: localStorage.getItem("userToken") },
      };
      const res = await axios.delete(
        process.env.REACT_APP_API_HOSTNAME + `/api/v1/deleteAd/${item}`,
        config
      );
      getAdd()
  };



const getAdd = async() =>{

  const config = {
    headers: { token: localStorage.getItem("userToken") },
  }
  const res = await axios.get( process.env.REACT_APP_API_HOSTNAME + "/api/v1/getAllads",config);
  setaddList(res?.data?.ads)
}
console.log("addListaddList", addList);
  useEffect (() =>{
    getAdd()
  },[])

  return (
    <div
      className={`m-2 md:m-10 p-2 md:p-10 bg-white rounded-3xl ${
        currentMode === "Dark" ? "ag-theme-alpine-dark" : "ag-theme-alpine"
      } h-[500px]`}
    >
      <Header title="Advertisment" category="Page" />
      <div className="ag-theme-alpine h-[70%] w-[100%]" >
        <AgGridReact rowData={addList} columnDefs={columnDefs}></AgGridReact>
      </div>
    </div>
  );
};

export default Announcements;
